import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { DefaultLoader } from '#components/default-loader'
import { SessionsListPage } from '#features/sessions/sessions-list-page.tsx'

const searchSchema = z.object({
  filter: z.enum(['active', 'archived']).catch('active').default('active'),
})

export const Route = createFileRoute('/_app/$workspace/_dashboard/sessions/')({
  head: () => ({ meta: [{ title: 'Sessions' }] }),
  component: SessionsListPage,
  pendingComponent: DefaultLoader,
  validateSearch: searchSchema,
})
